export default __webpack_public_path__ + "static/media/btnIos.6326b0cb.svg";